module.exports = __webpack_public_path__ + "img/trash-icon.23e99379.svg";